import { Contacto } from './contacto.model';

export class Tarea {
    constructor(
        public id: string,
        public asunto: string, 
        public estado: string,
        public fecha_hora_inicio: Date, 
        public fecha_hora_vencimiento: Date, 
        public fecha_realizacion: Date,
        public parent_type: string,
        public parent_name: string,
        public parent_id: string,
        public contact_name: string,
        public contact_id: string,
        public prioridad: string,
        public descripcion: string,
        public contactos: string
    ) {}
}
